










































































































































































































































































































import Vue from "vue";
import VueCompositionApi, {
  ref,
  onBeforeMount,
  onMounted,
  watch,
  computed,
} from "@vue/composition-api";
import appBridge from "./helpers/appBridge";
import formatScheduleDate from "./helpers/formatScheduleDate";

export default Vue.extend({
  name: "App",
  setup(props, context: any): any {
    //
    const drawer = ref(true);
    const rightDrawer = ref(true);
    const topUpModal = ref(false);
    const topUpAmount = ref(10);
    const appReady = computed(() => context.root.$store.state.appReady);
    const storeBalance = computed(
      () => context.root.$store.state.shop.storeBalance
    );

    const error = computed(() => {
      return context.root.$store.state.error;
    });

    const success = computed(() => {
      return context.root.$store.state.success;
    });

    function goToRoute(route) {
      if (route === context.root.$route.path) {
        return;
      }
      context.root.$router.push(route);
    }

    function handleTopUp() {
      topUpModal.value = true;
    }

    function handleConfirmTopUp() {
      context.root.$mixpanel.track("Click", {
        Parent: "Topup",
        Value: topUpAmount.value,
      });
      context.root.$store.dispatch("shop/topUp", { amount: topUpAmount.value });
    }

    function onClose() {
      context.root.$store.dispatch("clearError");
      context.root.$store.dispatch("clearSuccess");
    }

    watch(
      () => error.value,
      (first, second) => {
        setTimeout(() => {
          onClose();
        }, 6000);
      }
    );

    watch(
      () => success.value,
      (first, second) => {
        setTimeout(() => {
          onClose();
        }, 6000);
      }
    );

    const isVerificationAlertDismissed = ref(false);

    onMounted(() => {
      const val = localStorage.getItem("dismissVerificationAlert");

      if (val === "true") {
        isVerificationAlertDismissed.value = true;
      } else {
        isVerificationAlertDismissed.value = false;
      }
    });

    const storeDetails = computed(() => {
      return context.root.$store.state.store;
    });

    const verificationAlert = computed(() => {
      console.log(storeDetails.value);
      if (isVerificationAlertDismissed.value) {
        return false;
      } else if (storeDetails.value.verifiedUsPhoneNumber) {
        return false;
      } else if (!storeDetails.value.enfonicaAccessToken) {
        return false;
      } else {
        return true;
      }
    });

    function redirectTo(url) {
      appBridge(context.root.$store.state.store).redirectToRemote(url);
    }

    function dismissVerficationAlert() {
      localStorage.setItem("dismissVerificationAlert", "true");
      isVerificationAlertDismissed.value = true;
    }

    return {
      verificationAlert,
      redirectTo,
      onClose,
      error,
      success,
      drawer,
      rightDrawer,
      appReady,
      goToRoute,
      storeBalance,
      topUpModal,
      topUpAmount,
      handleTopUp,
      handleConfirmTopUp,
      dismissVerficationAlert,
    };
  },
});
